export default "__VITE_ASSET__B6H_NmYd__"